import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import Modal from '../../modal/Modal.react';
import Form from '../../common/react-form/Form.react';
var PpcProductCategoryAdd = function PpcProductCategoryAdd(_ref) {
  var app = _ref.app;
  var dispatch = useDispatch();
  var formRef = useRef();
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Add Product Category"
  }, /*#__PURE__*/React.createElement(Form, {
    ref: formRef,
    data: [{
      name: 'title',
      required: true
    }],
    submitBtn: {
      label: 'Add',
      onSubmit: function onSubmit(formData) {
        formData.app = app;
        dispatch({
          type: ppcActions.productCategory,
          payload: {
            formData: formData,
            method: 'post'
          }
        });
        dispatch({
          type: modalActions.hide
        });
      }
    }
  }));
};
export default PpcProductCategoryAdd;